/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // disable click on menu items with a dropdown or mega menu
  document.addEventListener('click', function (e) {
  const link = e.target.closest('.menu__item > a.navlink');

  if (!link) return;

  const menuItem = link.parentElement;

  if (menuItem.classList.contains('parent') || menuItem.classList.contains('grandparent')) {
    e.preventDefault();
  }
});







  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
